var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/components/x-buildify-global-settings-base-templates.ts
import "@adornis/chemistry/elements/components/stack/x-stack";
import { html, nothing } from "lit";
import { customElement } from "lit/decorators.js";
import { repeat } from "lit/directives/repeat.js";
import { BaseCustomContent } from "../../db/extensions/BaseCustomContent.js";
import { BuildifyGlobalSettingBaseTemplate } from "../../db/GlobalSettings.js";
import "../extensions/x-extension-editor.js";
import { ExtensionsConsumer } from "../globals/consumer.js";
import { XBuildifyGlobalSettingsFormField } from "./x-buildify-global-settings-formfield.js";
import "./x-buildify-size-picker.js";
var XBuildifyGlobalSettingsBaseTemplates = class extends XBuildifyGlobalSettingsFormField {
  constructor() {
    super(...arguments);
    this._consumedExtensions = ExtensionsConsumer(this);
  }
  render() {
    return html`
      <x-flex space="md">
        ${repeat(
      (this._consumedExtensions.value ?? []).filter((e) => !(new e.class({}) instanceof BaseCustomContent)),
      (extension) => extension.class._class,
      (extension) => {
        const data = (this.value.value ?? []).filter((data2) => data2.template instanceof extension.class);
        return html`
              <stack-item
                name=${extension.toolbar?.text.default ?? extension.class._class}
                .renderContent=${() => html`
                  <x-flex space="md">
                    ${data.map(
          (data2) => html`
                        <stack-item
                          name=${data2.name}
                          .renderContent=${() => html`
                            <d-flex space="sm">
                              <d-input
                                placeholder="Bezeichnung"
                                .value=${data2.name}
                                @value-picked=${(e) => {
            data2.name = e.detail.value;
          }}
                              ></d-input>

                              <x-extension-editor hide-actions .content=${data2.template}></x-extension-editor>
                            </d-flex>
                          `}
                        >
                        </stack-item>
                      `
        )}
                    ${!data.length ? html` <x-text>Keine Vorlagen definiert</x-text> ` : nothing}

                    <x-button
                      @click=${() => {
          this.value.next([
            ...this.value.value ?? [],
            new BuildifyGlobalSettingBaseTemplate({
              name: "Neues Template",
              template: new extension.class({})
            })
          ]);
          this.dispatchEvent(new CustomEvent("value-changed", { detail: { value: this.value.value } }));
          this.requestUpdate();
        }}
                    >
                      Hinzufügen
                    </x-button>
                  </x-flex>
                `}
              >
              </stack-item>
            `;
      }
    )}
      </x-flex>
    `;
  }
};
XBuildifyGlobalSettingsBaseTemplates = __decorateClass([
  customElement("x-buildify-global-settings-base-templates")
], XBuildifyGlobalSettingsBaseTemplates);
export {
  XBuildifyGlobalSettingsBaseTemplates
};
